import {
  Box,
  Icon,
  IconColor,
  SxProps,
  Typography,
  TypographyVariant,
} from "@outschool/backpack";
import { IconDefinition } from "@outschool/icons";
import React from "react";

export function FrequencyTextWithPerClass({
  paymentFrequencyText,
  priceText,
  perClassText,
  isSearchCard,
  useOneOnOneTile = false,
}: {
  paymentFrequencyText: string;
  priceText: string;
  perClassText: string;
  isSearchCard: boolean;
  useOneOnOneTile?: boolean;
}) {
  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        flex: isSearchCard ? "1 1 50%" : "1 1 max-content",
        backgroundColor: useOneOnOneTile
          ? "#f7f7f7"
          : isSearchCard
          ? "#E6E9FF"
          : "white",
        borderBottom: "1px solid",
        borderColor: isSearchCard ? "grey.200" : "gray",
      }}
    >
      <Box
        flex
        sx={{
          borderBottom: "1px solid",
          borderColor: isSearchCard ? "grey.200" : "grey.400",
          justifyContent: "center",
          padding: "0.5em 0.75em",
          alignItems: "center",
        }}
      >
        <Typography
          variant="inherit"
          sx={{
            color: "grey.900",
            fontWeight: "fontWeightMedium",
            textWrap: "balance",
          }}
        >
          {paymentFrequencyText}
        </Typography>
      </Box>
      <Box
        flex
        data-test-id="perclass-breakdown"
        sx={{
          justifyContent: "center",
          padding: "0.5em 0.75em",
          alignItems: "center",
          flexWrap: "wrap",
          columnGap: "0.3em",
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: "fontWeightBold" }}>
          {priceText}
        </Typography>
        <Typography variant="body1">{perClassText}</Typography>
      </Box>
    </Box>
  );
}

export function FrequencyTextOnly({
  paymentFrequencyText,
  isSearchCard,
  useOneOnOneTile = false,
}: {
  paymentFrequencyText: string;
  isSearchCard: boolean;
  useOneOnOneTile?: boolean;
}) {
  return (
    <Box
      flex
      sx={{
        flex: isSearchCard ? "1 1 50%" : "1 1 max-content",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: useOneOnOneTile
          ? "#f7f7f7"
          : isSearchCard
          ? "#E6E9FF"
          : "white",
        borderBottom: "1px solid",
        borderColor: isSearchCard ? "grey.200" : "gray",
        padding: "0.5em 0.75em",
      }}
    >
      <Typography
        variant="inherit"
        sx={{
          color: "grey.900",
          fontWeight: "fontWeightMedium",
          textWrap: "balance",
        }}
      >
        {paymentFrequencyText}
      </Typography>
    </Box>
  );
}

export function PriceTitleFormat({
  price,
  subtitle,
}: {
  price: string;
  subtitle: string;
}) {
  return (
    <Box
      flex
      sx={{
        flexWrap: "wrap",
        alignItems: "baseline",
        justifyContent: "center",
        columnGap: "0.5em",
      }}
    >
      <Typography
        variant="h3"
        sx={(theme: any) => ({
          [theme.breakpoints.up("md")]: {
            // Override the h3 variant fontSize at md breakpoint
            fontSize: "1.5em",
          },
          verticalAlign: "bottom",
        })}
      >
        {price}
      </Typography>
      <Typography variant="inherit" sx={{ fontSize: "0.75em" }}>
        {subtitle}
      </Typography>
    </Box>
  );
}

export function IconBullet({
  icon,
  iconColor,
  iconSx,
  text,
  typographyVariant = "inherit",
}: {
  icon: IconDefinition;
  iconColor?: IconColor;
  iconSx?: SxProps;
  text: string | null;
  typographyVariant?: TypographyVariant;
}) {
  return (
    <Box flex sx={{ gap: "0.5em", alignItems: "center" }}>
      <Icon
        icon={icon}
        color={iconColor}
        sx={{
          width: "1.25em",
          ...iconSx,
        }}
      />
      <Typography variant={typographyVariant}>{text}</Typography>
    </Box>
  );
}
